import { render, staticRenderFns } from "./ThemeEditor.vue?vue&type=template&id=71020daa&scoped=true"
import script from "./ThemeEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThemeEditor.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ThemeEditor.vue?vue&type=style&index=0&id=71020daa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71020daa",
  null
  
)

export default component.exports